import React from 'react';
import PropTypes from 'prop-types';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout';
import ResetPasswordWithTokenDialogFooter from './Components/ResetPasswordWithTokenDialogFooter';
import ResetPasswordWithTokenDialogContent from './Components/ResetPasswordWithTokenDialogContent';
import ResetPasswordWithTokenDialogHeader from './Components/ResetPasswordWithTokenDialogHeader';
import './ResetPasswordWithTokenDialog.custom.scss';

function ResetPasswordWithTokenDialog({
  close,
  isLoading,
  trackAdobeAnalyticsError,
  setNewPassword,
  newPassword,
  setConfirmationPassword,
  confirmationPassword,
  submit,
}) {
  const [requestSent, setRequestSent] = React.useState(false);

  const handleSubmit = () => {
    if (!requestSent) {
      setRequestSent(true);
    }
    submit();
  };

  return (
    <GeneralDialogLayout
      selfClose={close}
      className="reset-password-with-token-dialog"
      size="md"
      layoutType="nothing"
      movable={false}
      header={<ResetPasswordWithTokenDialogHeader />}
      footer={<ResetPasswordWithTokenDialogFooter submit={handleSubmit} close={close} isLoading={isLoading} />}
    >
      <ResetPasswordWithTokenDialogContent
        requestSent={requestSent}
        newPassword={newPassword}
        confirmationPassword={confirmationPassword}
        setNewPassword={setNewPassword}
        setConfirmationPassword={setConfirmationPassword}
        isLoading={isLoading}
        trackAdobeAnalyticsError={trackAdobeAnalyticsError}
      />
    </GeneralDialogLayout>
  );
}

ResetPasswordWithTokenDialog.propTypes = {
  isLoading: PropTypes.bool,
  trackAdobeAnalyticsError: PropTypes.func.isRequired,
  newPassword: PropTypes.object.isRequired,
  setNewPassword: PropTypes.func.isRequired,
  confirmationPassword: PropTypes.object.isRequired,
  setConfirmationPassword: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
};

export default ResetPasswordWithTokenDialog;
